const dashboard = {
  // User dashboard
  user_dash_title: 'User Panel',
  user_dash_profile: 'Profile',
  user_dash_favorites: 'Favorites',
  user_dash_consultations: 'Consultations',
  user_dash_compare: 'Compare',
  user_dash_recommendations: 'Recommendations',
  user_dash_diary: 'Treatment Diary',
  user_dash_notifications: 'Notifications',
  user_dash_contracts: 'Contracts',
  user_dash_password: 'Change Password',
  user_dash_logout: 'Logout',

  // Institution dashboard
  inst_dash_title: 'Institution Panel',
  inst_dash_overview: 'Overview',
  inst_dash_profile: 'Institution Profile',
  inst_dash_appointments: 'Appointment Management',
  inst_dash_analytics: 'Analytics',
  inst_dash_membership: 'Membership',
  inst_dash_contracts: 'Contracts',
  inst_dash_reconciliation: 'Reconciliation',
  inst_dash_notifications: 'Notifications',
  inst_dash_logout: 'Logout',

  // Admin dashboard
  admin_dash_title: 'Admin Panel',
  admin_dash_overview: 'Overview',
  admin_dash_institutions: 'Institution Management',
  admin_dash_users: 'User Management',
  admin_dash_consultations: 'Consultations',
  admin_dash_contracts: 'Contract Management',
  admin_dash_packages: 'Package Management',
  admin_dash_stats: 'Statistics',
  admin_dash_reports: 'Reports',
  admin_dash_settings: 'Settings',
  admin_dash_logout: 'Logout',

  // User dashboard - page level
  user_dash_welcome: 'Welcome, {{name}}',
  user_dash_tab_profile: 'Profile & Notifications',
  user_dash_tab_consultations: 'My Consultation Requests',
  user_dash_tab_contracts: 'My Contracts',
  user_dash_tab_password: 'Change Password',
  user_dash_loading: 'Checking session...',
  user_dash_remember_me: 'Remember Me',
  user_dash_back_to_login: 'Back to login page',
  user_dash_forgot_title: 'Forgot Password',
  user_dash_forgot_desc: 'Enter your registered email address and we\'ll send you a password reset link.',
  user_dash_forgot_send: 'Send Password Reset Link',
  user_dash_forgot_sending: 'Sending...',
  user_dash_forgot_sent_title: 'Email Sent!',
  user_dash_forgot_sent_desc: 'A password reset link has been sent to <strong>{{email}}</strong>.',
  user_dash_forgot_spam: 'If you can\'t find the email, check your spam folder.',
  user_dash_back_to_login_btn: 'Back to Login',
  user_dash_login_title: 'User Login',
  user_dash_login_desc: 'Manage your account and view your contracts',
  user_dash_fill_all: 'Please fill in all fields',
  user_dash_login_failed: 'Login failed',
  user_dash_no_account: 'Don\'t have an account?',
  user_dash_register: 'Sign Up',
  // Email change modal
  email_change_title: 'Email Change',
  email_change_subtitle: 'Your login credentials will be updated',
  email_change_desc: 'You are changing your email address to <strong>{{email}}</strong>.',
  email_change_warning: 'After this change, you will need to log in with your <strong>new email address</strong>. Supabase may send a verification email — check your inbox.',
  email_change_confirm: 'Yes, Update',
  email_change_saving: 'Saving...',
  email_change_cancel: 'Cancel',
  // Profile tab
  profile_user_id: 'User ID',
  profile_copy: 'Copy',
  profile_copied: 'Copied!',
  profile_title: 'Profile Information',
  profile_saved: 'Changes saved.',
  profile_gender: 'Gender',
  profile_male: 'Male',
  profile_female: 'Female',
  profile_other: 'Prefer not to say',
  profile_first_name: 'First Name',
  profile_last_name: 'Last Name',
  profile_email: 'Email',
  profile_phone: 'Phone',
  profile_country: 'Country',
  profile_country_placeholder: 'Select country',
  profile_city: 'City',
  profile_city_placeholder: 'Select city',
  profile_city_select_country: 'Select country first',
  profile_search_country: 'Search country...',
  profile_search_phone: 'Search country or code...',
  profile_no_result: 'No results found',
  profile_save_btn: 'Save Changes',
  // Notifications section
  notif_title: 'Notification Preferences',
  notif_desc: 'Choose which notifications you want to receive',
  notif_saved: 'Notification preferences saved.',
  notif_email_consult: 'Consultation Request Email Notification',
  notif_email_consult_desc: 'Receive an email when request status changes',
  notif_email_newsletter: 'Newsletter Emails',
  notif_email_newsletter_desc: 'Stay informed about health tourism developments',
  notif_sms_consult: 'SMS Notification',
  notif_sms_consult_desc: 'Receive an SMS when consultation request is approved',
  notif_sms_reminder: 'Reminder Notifications',
  notif_sms_reminder_desc: 'Receive a reminder before consultation',
  notif_save_btn: 'Save Preferences',
  // Password tab
  pwd_title: 'Change Password',
  pwd_saved: 'Your password has been changed successfully.',
  pwd_current: 'Current Password',
  pwd_new: 'New Password',
  pwd_new_placeholder: 'At least 6 characters',
  pwd_confirm: 'Confirm New Password',
  pwd_confirm_placeholder: 'Re-enter password',
  pwd_mismatch: 'Passwords do not match',
  pwd_submit: 'Change Password',
  pwd_verifying: 'Verifying...',
  pwd_strength_weak: 'Weak',
  pwd_strength_medium: 'Medium',
  pwd_strength_strong: 'Strong',
  pwd_err_current: 'Enter your current password',
  pwd_err_min: 'New password must be at least 6 characters',
  pwd_err_mismatch: 'New passwords do not match',
  pwd_err_same: 'New password cannot be the same as current password',
  pwd_err_unexpected: 'An unexpected error occurred. Please try again.',
  // Consultations tab
  consult_tab_loading: 'Loading...',
  consult_tab_empty: 'You have no consultation requests yet',
  consult_tab_explore: 'Explore Institutions',
  consult_tab_cancel: 'Cancel',
  consult_tab_cancel_confirm: 'Are you sure you want to cancel this consultation request?',
  consult_tab_cancelled: 'Consultation request cancelled',
  consult_tab_cancel_failed: 'Cancellation failed',
  consult_tab_evaluate: 'Evaluate',
  consult_tab_view_inst: 'View Institution',
  consult_tab_appt_info: 'Appointment Information',
  consult_tab_appt_date: 'Date',
  consult_tab_appt_note: 'Note',
  consult_tab_review_title: 'Write a Review',
  consult_tab_review_rating: 'Your Rating',
  consult_tab_review_comment: 'Your Comment',
  consult_tab_review_comment_ph: 'Share your experience...',
  consult_tab_review_recommend: 'I recommend this institution',
  consult_tab_review_submit: 'Submit',
  consult_tab_review_cancel: 'Cancel',
  consult_tab_review_sent: 'Your review has been submitted, it will be published after approval',
  consult_tab_review_failed: 'Review could not be submitted',
  consult_tab_load_failed: 'Consultation requests could not be loaded',
  consult_tab_status_waiting: 'Waiting',
  consult_tab_status_appointed: 'Appointment Given',
  consult_tab_status_completed: 'Completed',
  consult_tab_status_cancelled: 'Cancelled',
  consult_tab_status_rejected: 'Rejected',
  // Contracts tab
  contracts_title: 'My Contracts',
  contracts_desc: 'You can view the contracts you have approved and their current versions.',
  contracts_loading: 'Loading...',
  contracts_empty: 'No contracts found yet',
  contracts_agreed_version: 'Version You Approved',
  contracts_outdated: 'Current version: {{version}} available',
  contracts_up_to_date: 'You approved the current version',
  contracts_not_agreed: 'You have not approved this contract yet',
  contracts_current_version: 'Current Version',
  contracts_effective_date: 'Effective Date',
  contracts_view_full: 'View Full Content',
  contracts_close: 'Close',
  contracts_version_label: 'Version',
  contracts_type_user_terms: 'Site Membership and Usage Agreement',
  contracts_type_user_kvkk: 'KVKK Consent Agreement',
  contracts_type_user_marketing: 'Marketing Communication Agreement',

  // Login forms
  login_email: 'Email',
  login_password: 'Password',
  login_submit: 'Login',
  login_logging_in: 'Logging in...',
  login_error: 'Invalid email or password.',
  login_forgot_password: 'Forgot Password?',
  login_no_account: 'Don\'t have an account?',
  login_register: 'Sign Up',
  login_user_title: 'User Login',
  login_institution_title: 'Institution Login',
  login_admin_title: 'Admin Login',
};

export default dashboard;
